/**
 * The action bar shown above the iol table. Includes a search field and
 * filters to help find shipments.
 */

import { useMemo } from "react";
import { TableActionBar } from "@amzn/meridian/table";
import Row from "@amzn/meridian/row";
import HorizontalStickyContainer from "../../app/horizontal-sticky-container";

const HorizontalStickyRow = props => (
  <HorizontalStickyContainer Component={Row} {...props} />
)
const InstockDetailsActionBar = props => {
  const Wrapper = props.stick ? HorizontalStickyRow : Row
  const instockSnapshot = props.instockSnapshot;
  
  // Memoize the formatted date string to prevent unnecessary re-renders
  const formattedDate = useMemo(() => {
    if (!instockSnapshot) return "";
    return new Date(instockSnapshot).toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }, [instockSnapshot]); // Only recalculate when instockSnapshot changes
  
  return (
    <Wrapper widths="fill" >
      <TableActionBar alignmentHorizontal="end">
        {`Inventory Snapshot Time (Local): ${formattedDate}`}
      </TableActionBar>
    </Wrapper>
  )
}
export default InstockDetailsActionBar
